import { ThemeProvider } from '@mui/material';
import React, { Component, Fragment } from 'react'
import '../resources/styles/app.css'
import Routes from './Routes'
import theme from '../resources/styles/theme.js/index'

class App extends Component {
  render() {
    return (
      <Fragment>
        <ThemeProvider theme={theme}>
          <style>
            {`
            #beduka-enem-app {
            flex: 1;
            width: 100%;
            height: 100%;
            }
          `}
          </style>
          <Routes />
        </ThemeProvider>
      </Fragment>
    )
  }
}

export default App;
